/** @param {boolean} hasHeader @param {import('@mui/material').SxProps | undefined} paperSx */
export function floatingMenuPaperSx(hasHeader, paperSx) {
  return [
    {
      boxSizing: 'border-box',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: hasHeader ? '240px' : 'fit-content',
      minWidth: hasHeader ? '240px' : 'fit-content',
      maxWidth: 'none',
      height: 'fit-content',
      minHeight: 'fit-content',
      padding: '6px',
      gap: '8px',
      bgcolor: 'common.white',
      border: '1px solid',
      borderColor: 'divider',
      boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.06)',
      borderRadius: 'var(--app-radius-md)',
      overflow: 'visible',
      marginLeft: '8px',
    },
    ...(paperSx ? [paperSx] : []),
  ]
}
